export function formatTime(ts) {
  if (!ts) return "—";
  return new Date(ts).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function splitEmail(email) {
  const [local = "", domain = ""] = (email || "").split("@");
  return { local, domain };
}

export const RANGES = [
  { value: "1", label: "Today", phrase: "today" },
  { value: "7", label: "Last 7 days", phrase: "the last 7 days" },
  { value: "30", label: "Last 30 days", phrase: "the last 30 days" },
  { value: "90", label: "Last 90 days", phrase: "the last 90 days" },
];

export function rangePhrase(days) {
  return RANGES.find(r => r.value === String(days))?.phrase ?? `the last ${days} days`;
}
